import Menu, { MenuProps } from '@mui/material/Menu'
import React, { ReactElement } from 'react'
import {
    getAnchorOrigin,
    getArrowPosition,
    getMargin,
    getTransformOrigin,
} from '../utils'
import { MenuContext } from './MenuRoot'

interface MenuPortalProps extends Omit<MenuProps, 'open' | 'anchorEl' | 'id'> {
    children: React.ReactNode
}

export default function MenuList({ children, ...props }: MenuPortalProps) {
    return (
        <MenuContext.Consumer>
            {({ id, open, anchorEl, handleClose, position, arrow }) => (
                <Menu
                    data-testid="popup-menu"
                    id={id + '-menu'}
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    aria-labelledby={id + '-trigger'}
                    anchorOrigin={getAnchorOrigin(position)}
                    transformOrigin={getTransformOrigin(position)}
                    {...props}
                    slotProps={{
                        paper: {
                            ...props?.slotProps?.paper,
                            ...(arrow && {
                                elevation: 3,
                                sx: theme => ({
                                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                    // @ts-expect-error
                                    ...props?.slotProps?.paper?.sx,
                                    ...getMargin(position),
                                    overflowX: 'auto',
                                    overflowY: 'auto',
                                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.25))',
                                    backgroundImage:
                                        'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))',
                                    '&::before': {
                                        content: '""',
                                        position: 'absolute',
                                        // marginRight: 0.85,
                                        // marginLeft: 0.85,
                                        ...getArrowPosition(position, anchorEl),
                                        width: 10,
                                        height: 10,
                                        backgroundColor:
                                            theme.palette.background.paper,
                                        boxShadow: theme.shadows[1],
                                        backgroundImage:
                                            'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))',
                                        clipPath:
                                            'polygon(-5px -5px, calc(100% + 5px) -5px, calc(100% + 5px) calc(100% + 5px))',
                                    },
                                }),
                            }),
                        },
                    }}
                >
                    {React.Children.map(children, (child, index) => {
                        let itemId: string | number
                        if (!child) return null
                        // biome-ignore lint/correctness/noUnsafeOptionalChaining: child pode ser undefined, checked above
                        if (id in (child as ReactElement)?.props) {
                            itemId = (child as ReactElement)?.props[id]
                        } else {
                            itemId = index
                        }

                        return React.cloneElement(child as React.ReactElement, {
                            id: id + '-menu__item-' + itemId,
                        })
                    })}
                </Menu>
            )}
        </MenuContext.Consumer>
    )
}
